
import { ISectorSettingDTO } from '@interfaces/map/dto/sectorsDTO';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { TVendorsValues } from '@enums/common';

export function prepareBandOptions(
	bands: TSelectOptionType[],
	cellSettingsList: ISectorSettingDTO[],
	vendor: TVendorsValues,
): TSelectOptionType[] {
	return bands.map((band) => {
		const existingCellsSettingsOfVendor = cellSettingsList.filter(
			cellSettings => cellSettings.vendor.name === vendor,
		);
		const existingCellSettings = existingCellsSettingsOfVendor.find((cellSettings) =>
			cellSettings.band.name === band?.value,
		);

		return {
			...band,
			disabled: !!existingCellSettings,
			...(existingCellSettings && {
				tooltipText: 'Sectors settings already exist for this band.',
			}),
		};
	});
}
